export * from './post';
export * from './page';
export * from './page-homepage/page-homepage';
export * from './page-article/page-article';
export * from './page-content/page-content';
export * from './page-category/page-category';
export * from './page-cookies/page-cookies';


// WEBPACK FOOTER //
// ./assets/_js/components/post-types/index.js